import DeviceFragment from 'components/core/DeviceFragment';
import { useEqualHeights } from 'components/hooks/sizing';
import { useEffect } from 'react';
import { VStack, HStack } from 'reaction';
import GitHubAchievment from 'components/portfolio/components/GitHubAchievment';
import './GitHubAchievmentsSection.css';

export default function GitHubAchievmentsSection() {
    const githubAchievmentsEqualHeights = useEqualHeights(
        () =>
            Array.from(document.querySelectorAll('.github-achievment')).filter(
                e => !e.classList.contains('mobile'),
            ) as HTMLElement[],
    );

    useEffect(() => {
        function triggerResize() {
            githubAchievmentsEqualHeights.clear();
            githubAchievmentsEqualHeights.resize();
        }

        function cleanup() {
            githubAchievmentsEqualHeights.clear();

            document.removeEventListener('resize', triggerResize);
        }

        triggerResize();

        window.addEventListener('resize', triggerResize);

        return cleanup;
    });

    function Achievments() {
        return (
            <>
                <GitHubAchievment
                    name='Arctic Code Vault Contributor'
                    description='@VirajShah21 contributed code to 3 repositories in the 2020 GitHub Archive Program.'
                    badge='https://github.githubassets.com/images/modules/profile/achievements/arctic-code-vault-contributor-default.png'>
                    This achievment is given to contributors that have contributed code the Arctic
                    Code Vault. For more information click{' '}
                    <a href='https://archiveprogram.github.com/'>here</a>.
                </GitHubAchievment>
                <GitHubAchievment
                    name='Pull Shark'
                    description='@VirajShah21 opened pull requests that have been merged.'
                    badge='https://github.githubassets.com/images/modules/profile/achievements/pull-shark-silver.png'>
                    This achievment is given to contributors that have opened pull requests that
                    have been merged.
                </GitHubAchievment>
                <GitHubAchievment
                    name='YOLO'
                    description='You want it? You merge it.'
                    badge='https://github.githubassets.com/images/modules/profile/achievements/yolo-default.png'>
                    This achievment is given to contributors that live on the edge and merge their
                    branches without a code review. Oops 🤪
                </GitHubAchievment>
            </>
        );
    }

    return (
        <VStack id='github-achievments' className='github-achievments'>
            <h2>GitHub Achievments</h2>
            <DeviceFragment type={['desktop', null]}>
                <HStack justify='around' className='achievments-gallery'>
                    <Achievments />
                </HStack>
            </DeviceFragment>
            <DeviceFragment type={[null, 'tablet']}>
                <VStack justify='start' align='center' className='achievments-gallery'>
                    <Achievments />
                </VStack>
            </DeviceFragment>
        </VStack>
    );
}
